var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VirtualScrollTable',{staticClass:"share-watchlist-table",attrs:{"columns":_vm.columns,"data":_vm.subordinatesData,"columnHiddenOption":_vm.columnHiddenOption,"max-height":500,"checkbox-option":_vm.checkboxOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }